type EventMap = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [event: string]: any;
};

export class EventEmitter<Events extends EventMap = EventMap> {
  private listeners: {
    [K in keyof Events]?: Array<(data: Events[K]) => void>;
  } = {};

  on<K extends keyof Events>(
    eventName: K,
    callback: (data: Events[K]) => void
  ): () => void {
    if (!this.listeners[eventName]) {
      this.listeners[eventName] = [];
    }
    this.listeners[eventName]!.push(callback);
    return () => {
      this.off(eventName, callback);
    };
  }

  emit<K extends keyof Events>(eventName: K, data: Events[K]): void {
    if (this.listeners[eventName])
      for (const callback of this.listeners[eventName]) {
        callback(data);
      }
  }

  off<K extends keyof Events>(
    eventName: K,
    callback: (data: Events[K]) => void
  ): void {
    if (this.listeners[eventName]) {
      this.listeners[eventName] = this.listeners[eventName]!.filter(
        (listener) => listener !== callback
      );
    }
  }

  waitFor<K extends keyof Events>(
    eventName: K,
    timeoutMs: number
  ): Promise<Events[K]> {
    return new Promise((resolve, reject) => {
      const timeoutId = setTimeout(() => {
        unsubscribe();
        reject(new Error(`Timeout waiting for event "${String(eventName)}"`));
      }, timeoutMs);

      const unsubscribe = this.on(eventName, (data) => {
        clearTimeout(timeoutId);
        unsubscribe();
        resolve(data);
      });
    });
  }
}
